import { useEffect, useState } from 'react';
import { useStore } from 'zustand';

import { Button } from '@/components/ui/button/button.component';
import { useLoading } from '@/hooks/use-loading.hook';
import { forgotPassword } from '@/services/auth/login.service';
import { StepKeys } from '@/app/(main)/_components/sign-in-modal/_types/header-auth-modal-step-keys.enum';
import { loginDocumentNumberStore } from '@/store/login.store';
import { useProgressiveModal } from '@/components/ui/progressive-modal/progressive-modal.hook';
import { getLogger } from '@/logger/logger';
import { Typography } from '@/components/ui/typography/typography.component';
import { TypographyVariant } from '@/components/ui/typography/typography.type';
import { patientSacWhatsappMessage } from '@/utils/consts/cta-whatsapp-messages.consts';
import { useWhatsappLinkSimple } from '@/hooks/use-whatsapp/use-whatsapp-link-simple.hook';
import { phonePatientSac, visualPhonePatientSac } from '@/utils/consts/sac.consts';
import { Link } from '@/components/ui/link/link.component';

export const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const { isLoading, startLoading, stopLoading } = useLoading();
  const loginDocumentNumber = useStore(loginDocumentNumberStore, (state) => state.loginDocumentNumber);
  const { url } = useWhatsappLinkSimple(
    phonePatientSac,
    patientSacWhatsappMessage,
  );
  const { handleJump: jump } = useProgressiveModal<StepKeys>();

  useEffect(() => {
    const forgotPasswordFetch = async () => {
      startLoading();
      try {
        if (loginDocumentNumber) {
          const { email } = await forgotPassword(loginDocumentNumber);
          setEmail(email);
        }
        stopLoading();
      } catch (error) {
        const logger = getLogger('ForgotPasswordComponent');
        logger.error('Error in forgot password', { loginDocumentNumber }, error);
      }
    };
    forgotPasswordFetch();
  }, []);

  return isLoading
    ? (
        <div className="loading loading-lg"></div>
      )
    : (
        <div>
          <Typography variant={TypographyVariant.BODY_TEXT} className="mb-4">
            Enviamos um e-mail para
            {' '}
            <span className="font-semibold text-base">{email}</span>
            {' '}
            com instruções para criar uma
            nova senha.
          </Typography>
          <Typography variant={TypographyVariant.BODY_TEXT} className="text-gray-700 font-bold">
            Não tem mais acesso ao e-mail?
          </Typography>
          <Typography>
            Fale com o atendimento pelo WhatsaApp
            {' '}
            <Link href={url} className="text-green-500 font-bold" target="_blank">{visualPhonePatientSac}</Link>
          </Typography>
          <Button
            variant="default"
            color="primary"
            className="mt-6 text-xl"
            onClick={() => {
              jump({ key: StepKeys.LOGIN, returning: true });
            }}
          >
            Entendi
          </Button>
        </div>
      );
};
